import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges} from '@angular/core';
import * as _ from 'lodash';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import {IColor} from '../../../model/interface/IColor';
import {ColorService} from '../../services/color/color.service';

@Component({
  selector: 'app-color-selector',
  templateUrl: './color-selector.component.html',
  styleUrls: ['./color-selector.component.css'],
  animations: [
    trigger('select-color', [
      state('true', style({
        'height': '40px', 'width': '40px', 'margin-left': '5px', ' margin-right': '5px'
      })),
      state('false', style({
        'height': '30px', 'width': '30px', 'margin-left': '10px', ' margin-right': '10px'
      })),
      transition('true => false', animate('200ms ease-in')),
      transition('false => true', animate('200ms ease-out'))
    ])
  ]
})
export class ColorSelectorComponent implements OnInit, OnChanges {

  @Input() selected?: IColor[];
  @Output() change: EventEmitter<IColor[]> = new EventEmitter<IColor[]>();
  _selected?: IColor[];

  colores: IColor[] = [];

  constructor(
    private colorService: ColorService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    const selected: SimpleChange = changes.selected;
    this._selected = selected.currentValue;
    this.initColores();
  }

  ngOnInit() {
    this.colorService.get().subscribe((data) => {
      for (const o of data) {
        o.selected = false;
      }
      this.colores = data;
      this.initColores();
    });
  }

  initColores() {
    if (this._selected) {
      for (const col of this.colores) {
        const find = _.find(this._selected, {'id': col.id});
        if (find) {
          col.selected = true;
        }
      }
    }
  }

  selectedItem(item: IColor): void {
    item.selected = !item.selected;
    const result = _.filter(this.colores, {'selected': true});
    this.change.emit(result);
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/color-selector/color-selector.component.ts